const Routes = {
  Splash: 'Splash',
  Home: 'Home',
  Profile: 'Profile',
  Earning: 'Earning',
  Track: 'Track',
  SignUp: 'SignUp',
  LogIn: 'LogIn',
  Referral: 'Referral',
  ReferralSubmisionScreen: 'ReferralSubmisionScreen',
  BottomTabNavigation: 'BottomTabNavigation',
  UpdateProfile: 'UpdateProfile',
  ProfileSendOTP: 'ProfileSendOTP',
  ProfileOTPSubmit: 'ProfileOTPSubmit',
  CreateNewPasswordScreen: 'CreateNewPasswordScreen',
  GetStarted: 'GetStarted',
  DrawerNavigation: 'DrawerNavigation',
  PhoneNumberVerification: 'PhoneNumberVerification',
  VerifyPhoneNumberScreen : "VerifyPhoneNumberScreen",
};

export default Routes;
